export default __webpack_public_path__ + "images/5a1b88e48adc5a8f9bd064bd48973398-nye_homepage_banner_desktop.webp";